import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Linkedin } from 'lucide-react';
import NewsletterForm from './NewsletterForm';

const Footer = () => {
    return (
        <footer className="bg-black text-white border-t-4 border-black py-20 px-6">
            <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-12">
                <div className="col-span-2">
                    <Link to="/" className="inline-block mb-6">
                        <img src="/assets/logo.webp" alt="Unbox Creator" className="h-16 w-auto object-contain" />
                    </Link>
                    <p className="text-gray-400 max-w-md mb-8 leading-relaxed">
                        L'usine de <span className="text-white font-bold">packaging parfumé</span> préférée des créateurs.
                        <br />Technologie sensorielle • Design viral • Qualité industrielle.
                        <br /><span className="text-[#ffee00] font-black">Direct Usine. Sans Intermédiaire.</span>
                    </p>

                    <div className="mb-8 max-w-sm">
                        <h4 className="font-black text-white mb-4 uppercase tracking-widest text-xs">Newsletter</h4>
                        <NewsletterForm />
                    </div>
                    <div className="flex gap-4">
                        <a href="#" aria-label="Instagram" className="w-12 h-12 rounded-full border-2 border-white flex items-center justify-center text-white hover:bg-[#00f2ea] hover:border-[#00f2ea] hover:text-black transition-all hover:scale-110">
                            <Instagram size={20} />
                        </a>
                        <a href="#" aria-label="Twitter" className="w-12 h-12 rounded-full border-2 border-white flex items-center justify-center text-white hover:bg-[#ff0050] hover:border-[#ff0050] hover:text-white transition-all hover:scale-110">
                            <Twitter size={20} />
                        </a>
                        <a href="#" aria-label="LinkedIn" className="w-12 h-12 rounded-full border-2 border-white flex items-center justify-center text-white hover:bg-[#ffee00] hover:border-[#ffee00] hover:text-black transition-all hover:scale-110">
                            <Linkedin size={20} />
                        </a>
                    </div>
                </div>

                <div>
                    <h3 className="font-black text-white mb-6 uppercase tracking-widest text-sm border-b-2 border-[#00f2ea] pb-2 inline-block">Studio</h3>
                    <ul className="space-y-4 text-gray-400">
                        <li><a href="/#buybox" className="hover:text-[#00f2ea] transition font-bold">Nos Gammes</a></li>
                        <li><Link to="/vinted" className="hover:text-[#09B1BA] transition font-bold">Emballage Vinted</Link></li>
                        <li><Link to="/custom" className="hover:text-[#ffee00] transition font-bold">Sur Mesure (Pro)</Link></li>
                        <li><Link to="/guide" className="hover:text-[#00f2ea] transition font-bold">Guide des Tailles</Link></li>
                        <li><Link to="/blog" className="hover:text-white transition font-bold">Blog</Link></li>
                        <li><Link to="/contact" className="hover:text-[#ff0050] transition font-bold">Contact</Link></li>
                    </ul>
                </div>

                <div>
                    <h3 className="font-black text-white mb-6 uppercase tracking-widest text-sm border-b-2 border-[#ff0050] pb-2 inline-block">Légal</h3>
                    <ul className="space-y-4 text-gray-400">
                        <li><Link to="/about" className="hover:text-[#00f2ea] transition font-bold">À Propos</Link></li>
                        <li><Link to="/faq" className="hover:text-[#00f2ea] transition font-bold">FAQ</Link></li>
                        <li><Link to="/cgv" className="hover:text-[#00f2ea] transition font-bold">CGV</Link></li>
                        <li><Link to="/politique-de-retour" className="hover:text-white transition font-bold">Politique de Retour</Link></li>
                        <li><Link to="/legal" className="hover:text-[#ffee00] transition font-bold">Mentions Légales</Link></li>
                        <li><Link to="/privacy" className="hover:text-[#ff0050] transition font-bold">Confidentialité</Link></li>
                    </ul>
                </div>
            </div>

            <div className="max-w-7xl mx-auto mt-20 pt-8 border-t-2 border-gray-800">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="text-gray-500 text-sm">
                        © 2025 <span className="text-white font-bold">UnboxCreator Factory</span>. All rights reserved.
                    </div>
                    <div className="flex flex-wrap justify-center md:justify-end gap-2 text-sm">
                        <span className="bg-[#ffee00] text-black px-3 py-1 rounded-full font-black text-xs">
                            🇫🇷 DESIGNED IN LYON
                        </span>
                        <span className="bg-white text-black px-3 py-1 rounded-full font-black text-xs">
                            ✓ ECO-FRIENDLY
                        </span>
                        <span className="bg-[#00f2ea] text-black px-3 py-1 rounded-full font-black text-xs">
                            🛡️ REACH COMPLIANT
                        </span>
                        <span className="bg-white text-black px-3 py-1 rounded-full font-black text-xs">
                            🇪🇺 EUROPEAN STANDARDS
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
